import React from 'react';
import {Box, Typography, useMediaQuery} from "@mui/material";
import {useTranslation} from "react-i18next";

import GaByNumbersImg from "../../../../../assets/images/svgs/resources/ga_by_numbers.png";
import {DownloadButton, DownloadButtonType} from "../../../../../components";
import DownloadIcon from "../../../../../assets/images/svgs/download.svg";
import {gaResourceFilePath} from "../../../../../assets/data";
import {FeaturedContent, OfficeResources} from "../index"
import {styles} from "./forEyeCareProfessionals-helpers";
import {PageRowSection, ReferanceCard} from "../../../components";
import {theme} from "../../../../../utils";
import {desktopEdHubReferences, mobileEdHubReferences} from "../../../../../assets/data/educationHub/referancesData";
import TransMsg from "../../transMessage";

export const ForEyeCareProfessionals = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    return (
        <>
            <FeaturedContent />
            <OfficeResources />
            <PageRowSection
                title={t(TransMsg.GA_RESOURCES)}
                description={t(TransMsg.GA_RESOURCES_DESCRIPTION)}
                containerBoxSx={{ gap: "70px" }}
                sectionWrapperSx={{ pt: "77px", pb: "78px", backgroundColor: "#fff" }}
                rightWrapperSx={{ flex: isMobileX ? 1 : 0.8, display: "flex", justifyContent: "flex-end" }}
                rightElement={
                    <Box sx={{ ...theme.components.shadowCard, maxWidth: "386px" }}>
                        <img src={GaByNumbersImg} alt="ga-numbers" style={{ width: "100%" }} />
                        <Box sx={{ py: "18px", px: isMobileX ? "5px" : "32px", textAlign: isMobileX ? "left" : "none" }}>
                            <Typography sx={styles.gaByNumbersTitle}>
                                {t(TransMsg.GA_BY_NUMBERS)}
                            </Typography>

                            <Box sx={{ mt: "8px", display: "flex"}}>
                                <DownloadButton fileUrl={gaResourceFilePath} buttonIcon={DownloadIcon} buttonText="Download" buttonType={DownloadButtonType.Pdf} />
                            </Box>
                        </Box>
                    </Box>
                }
            />
            <ReferanceCard
                referanceData={isMobileX ? mobileEdHubReferences : desktopEdHubReferences}
            />
        </>
    )
};
